
import { getDb } from '../db/db';
import { PeriodLock } from '../../types';

/**
 * Period Lock Repository — idb implementation
 * Заменяет periodLockRepo из localforage для устранения конфликта
 */
export const periodLockRepository = {
    async getById(id: string): Promise<PeriodLock | undefined> {
        const db = await getDb();
        return db.get('periodLocks', id);
    },

    async getByPeriod(period: string): Promise<PeriodLock | undefined> {
        const db = await getDb();
        const locks = await db.getAllFromIndex('periodLocks', 'by-period', period);
        return locks[0]; // Return first match (should be unique)
    },

    async list(filters?: { period?: string }): Promise<{ data: PeriodLock[] }> {
        const db = await getDb();
        let all = await db.getAll('periodLocks');

        if (filters?.period) {
            all = all.filter(lock => lock.period === filters.period);
        }

        return { data: all };
    },

    async create(lock: PeriodLock): Promise<PeriodLock> {
        const db = await getDb();
        await db.put('periodLocks', lock);
        console.log('[PeriodLockRepo] Created lock for period:', lock.period);
        return lock;
    },

    async delete(id: string): Promise<void> {
        const db = await getDb();
        await db.delete('periodLocks', id);
        console.log('[PeriodLockRepo] Deleted lock:', id);
    },

    async getAll(): Promise<PeriodLock[]> {
        const db = await getDb();
        return db.getAll('periodLocks');
    },
};
